import React from 'react';
import classNames from 'clsx';

import { ClearFormMessageBoxProps } from './ClearFormMessageBox.interface';
import { useStyles } from './ClearFormMessageBox.styles';
import { LabelEnum } from 'app/shared/enums';

function ClearFormMessageBox({
  className,
  clearFunction,
  icon: Icon,
  subTitle,
  title,
}: ClearFormMessageBoxProps) {
  const classes = useStyles();

  return (
    <div className={classNames(classes.root, className)}>
      <Icon className={classes.icon} />
      <div className={classes.content}>
        <div className={classes.title}>{title}</div>
        <div>{subTitle}</div>
      </div>
      {clearFunction && (
        <div className={classes.aside}>
          <div>{LabelEnum.DoYouWantToStartAgain}</div>
          <div
            className={classNames(classes.action, 'focusVisibleOutline')}
            onClick={clearFunction}
            tabIndex={0}
            onKeyDown={(e) => {
              if (
                e.target === e.currentTarget &&
                (e.key === 'Enter' || e.key === ' ')
              ) {
                clearFunction();
              }
            }}
          >
            {LabelEnum.ClearForm}
          </div>
        </div>
      )}
    </div>
  );
}

export default ClearFormMessageBox;
